import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { GlobalLoadingIndicator } from "@/components/GlobalLoadingIndicator";
import { App } from "@/App";
import "./index.css";

const root = document.getElementById("root");
if (!root) {
  throw new Error("Root element #root not found");
}

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <GlobalLoadingIndicator />
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
